'tax_rates'.datatype({source: 'WC'})
'tax_rate_country'.field()
'tax_rate_state'.field()
'tax_rate'.field({numeric: true})
'tax_rate_name'.field()
'tax_rate_priority'.field()
'tax_rate_compound'.field()
'tax_rate_shipping'.field({numeric: true})
'tax_rate_order'.field()
'tax_rate_class'.field({indexed: true})
